// Module
var code = "<supplier-contacts\n  supplier-id=\"vm.supplier.id\"\n  supplier-name=\"vm.supplier.name\"\n>\n</supplier-contacts>\n";
// Exports
module.exports = code;